// eslint-disable-next-line
function dataStatisticsChartAdapter(postingLeadsCharts) {
  // Ver respuesta del servicio: panel/api/v1/statistic/publisher/daily`
  if (!postingLeadsCharts) return {};
  if (postingLeadsCharts) {
    return {
      impressions: {
        series: postingLeadsCharts.impressions && Object.values(postingLeadsCharts.impressions),
        categories: postingLeadsCharts.impressions && Object.keys(postingLeadsCharts.impressions),
        min: postingLeadsCharts.impressions && Math.min(...Object.values(postingLeadsCharts.impressions)) * 0.1,
        max:
          postingLeadsCharts.impressions && Math.max(...Object.values(postingLeadsCharts.impressions)) <= 1
            ? 2
            : postingLeadsCharts.impressions && Math.max(...Object.values(postingLeadsCharts.impressions)) * 1.2
      },
      period: postingLeadsCharts.period && postingLeadsCharts.period.map(r => `${r.startPeriod}/${r.endPeriod}`),
      views: {
        series: postingLeadsCharts.views && Object.values(postingLeadsCharts.views),
        categories: postingLeadsCharts.views && Object.keys(postingLeadsCharts.views),
        min: postingLeadsCharts.views && Math.min(...Object.values(postingLeadsCharts.views)) * 0.1,
        max:
          postingLeadsCharts.views && Math.max(...Object.values(postingLeadsCharts.views)) <= 1
            ? 2
            : postingLeadsCharts.views && Math.max(...Object.values(postingLeadsCharts.views)) * 1.25
      },
      userStat: {
        series: {
          total:
            postingLeadsCharts.userStat && Object.values(postingLeadsCharts.userStat).map(p => p.total - p.socialAds),
          leadForm: postingLeadsCharts.userStat && Object.values(postingLeadsCharts.userStat).map(p => p.leadForm),
          whatsapp: postingLeadsCharts.userStat && Object.values(postingLeadsCharts.userStat).map(p => p.whatsapp),
          viewData: postingLeadsCharts.userStat && Object.values(postingLeadsCharts.userStat).map(p => p.viewData),
          anonymous:
            postingLeadsCharts.userStat && Object.values(postingLeadsCharts.userStat).map(p => p.totalAnonymous)
        },
        categories: postingLeadsCharts.userStat && Object.keys(postingLeadsCharts.userStat),
        min: 0,
        max:
          postingLeadsCharts.userStat &&
          Math.max(...Object.values(postingLeadsCharts.userStat).map(p => p.total + p.totalAnonymous)) <= 1
            ? 2
            : postingLeadsCharts.userStat &&
              Math.max(...Object.values(postingLeadsCharts.userStat).map(p => p.total + p.totalAnonymous))
      }
    };
  }
}

export { dataStatisticsChartAdapter };
